import type { ClientApiV1CourseUserUserIdQueryString } from '../../../resources/@types/uccSchema';

export const enum CourseType {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export const enum PostSort {
  RECENT = 'RECENT',
  RECOMMEND = 'RECOMMEND',
  POPULAR = 'POPULAR',
}

export function isOfflineCourse(type: string): boolean {
  return type === CourseType.OFFLINE;
}

export function normalizeCourseSort(sort: string): ClientApiV1CourseUserUserIdQueryString['sort'] {
  if (sort === PostSort.RECOMMEND || sort === PostSort.RECENT || sort === PostSort.POPULAR) {
    return sort as ClientApiV1CourseUserUserIdQueryString['sort'];
  }

  return PostSort.RECENT;
}
